module.exports = __webpack_public_path__ + "img/Loeland_En_paadriver_for_landsmaalet.253efd34.jpg";